import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs';
import { TransitRequestComponent } from 'src/app/front-user/services/e-booking/transit-request/transit-request.component';
import { TransitService } from 'src/app/front-user/services/e-booking/transit-request/transit-request.service';
import { User } from 'src/app/front-user/shared/models/user.model';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { FormMode, Languages, ServiceStatus, ConfirmFeesPaymentDecision, GuaranteeType, TransitRequestWFSteps, TransitConfirmVesselEntranceDecision, PaymentStatus } from 'src/app/shared/models/enums.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { WFHistoryService } from 'src/app/shared/services/wfhistory.service';
import { ServicesRequestWorkflowHistory } from 'src/app/front-user/services/e-booking/shared/models/services-request-workflow-history.model';
import { TransitRequestCustomDTO } from 'src/app/shared/models/transit-request-custom-dto.model';
import { Router } from '@angular/router';
import { GuaranteeDeductionLettersComponent } from 'src/app/front-user/services/e-booking/guarantee-deduction-letters/guarantee-deduction-letters.component';
import { FeesEstimate } from 'src/app/front-user/services/e-booking/fees-estimation-request/fees-estimate.model';
import { AgentService } from 'src/app/front-user/services/e-booking/shared/services/agent.service';
import { AgentInfo } from 'src/app/front-user/services/e-booking/shared/models/agent.model';

@Component({
  selector: 'app-confirm-fees-payment',
  templateUrl: './confirm-fees-payment.component.html'
})
export class ConfirmFeesPaymentComponent implements OnInit {
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  stepId: number = TransitRequestWFSteps.ConfirmFeesPayment;
  confirmFeesPaymentForm: FormGroup;
  submitted = false;
  showRequest = false;
  isErrorMessage = false;
  lockTaskErrorMessage = false;
  decision = ConfirmFeesPaymentDecision;
  guaranteeType = GuaranteeType;
  guaranteeTypeKeys = Object.keys(this.guaranteeType);
  decisionKeys = Object.keys(this.decision);
  decisionValue: number;
  loading = false;
  baseRequestId: string = '';
  requestStatus: number;
  baseRequestDTO: BaseRequest;
  displayedLang: string;
  currentUser: User = new User();
  transitRequestCustomObj: TransitRequestCustomDTO = new TransitRequestCustomDTO();
  FeesEstimateObj: FeesEstimate = new FeesEstimate();
  agentInfo: AgentInfo = new AgentInfo();
  historicalGuaranteeType: any;
  historicalMaxValueNetTonnage: any;
  @ViewChild('GuaranteeDeductionLetters', { static: false }) GuaranteeDeductionLetters: GuaranteeDeductionLettersComponent;
  @Input() public isShow: boolean = true;
  isLoaded: boolean = false;
  responseObj: ResponseObject = new ResponseObject();
  numberRegex: string = '^[0-9]*$';
  stepHistoryId: any;
  stepData: any;
  requestStatuses: number[];

  constructor(
    private formBuilder: FormBuilder,
    private baseRequestService: BaseRequestService,
    private globalSrv: GlobalServices,
    private alertService: AlertService,
    private transitService: TransitService,
    private wfhistoryService: WFHistoryService,
    private agentService: AgentService,
    private router: Router
  ) {
    this.decisionKeys = this.decisionKeys.slice(this.decisionKeys.length / 2);
    this.guaranteeTypeKeys = this.guaranteeTypeKeys.slice(this.guaranteeTypeKeys.length / 2);
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    if (history.state.data && history.state.data.requestId) {
      this.stepHistoryId = history.state.data.stepHistoryId;
      this.baseRequestId = history.state.data.requestId;
      // this.baseRequestId = "A1EABCF5-33FE-427C-A871-93ECEEF05F0F";
      this.getBaseRequest();
    } else {
      window.history.back();
    }
    this.currentUser = this.globalSrv.user;
  }

  ngOnInit() {
    this.buildForm(null);
  }

  buildForm(decision) {
    this.confirmFeesPaymentForm = this.formBuilder.group({
      Decision: ['', Validators.required],
      TotalFees: new FormControl({ value: this.FeesEstimateObj.TotalFees, disabled: true }),
    });

    if (decision == ConfirmFeesPaymentDecision.CONFIRM) {
      this.confirmFeesPaymentForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        SwiftCode: ['', Validators.required],
        GuaranteeType: [this.historicalGuaranteeType, Validators.required],
        MaxValueNetTonnage: [this.historicalMaxValueNetTonnage],
        TotalFees: new FormControl({ value: this.FeesEstimateObj.TotalFees, disabled: true }),
      });
    } else if (decision == ConfirmFeesPaymentDecision.REQUIRE_MODIFICATION) {
      this.confirmFeesPaymentForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        ModificationReason: ['', Validators.required],
        TotalFees: new FormControl({ value: this.FeesEstimateObj.TotalFees, disabled: true }),
      });
    }
  }

  receiveFeesValue($event) {
    this.FeesEstimateObj = $event;
    if (this.baseRequestId && this.FeesEstimateObj) {
      this.confirmFeesPaymentForm.patchValue({
        TotalFees: this.FeesEstimateObj.TotalFees,
      });
    }
  }

  changeDecision(value) {
    this.buildForm(value);
    this.confirmFeesPaymentForm.patchValue({
      Decision: value
    });
    this.decisionValue = value;
  }

  onGuaranteeTypeChange(value) {
    if (value == GuaranteeType.PERMANENT) {
      this.confirmFeesPaymentForm.get('MaxValueNetTonnage')?.setValidators([Validators.required, Validators.pattern(this.numberRegex)]);
    } else {
      this.confirmFeesPaymentForm.get('MaxValueNetTonnage')?.clearValidators();
      this.confirmFeesPaymentForm.get('MaxValueNetTonnage')?.setValue('');
    }
    this.confirmFeesPaymentForm.get('MaxValueNetTonnage')?.updateValueAndValidity();
  }

  get f() { return this.confirmFeesPaymentForm.controls; }

  getBaseRequest() {
    this.baseRequestService.getBaseRequest(this.baseRequestId).subscribe(
      d => {
        this.baseRequestDTO = d.Data;
        // this.requestStatus = this.baseRequestDTO.StatusId;
        this.requestStatuses = this.baseRequestDTO.RequestStatuses.map(s => s.StatusId);
        this.isLoaded = true;
        if (history.state.data && history.state.data.isCompleted && history.state.data.StepId == this.stepId) { // Request History
          this.formMode = FormMode.Readonly;
          this.getTransitRequestWFHistoryById();
        } else if (!this.router.url.split('/')[2].includes('confirmFeesPayment')) {
          this.formMode = FormMode.Readonly;
          this.getTransitRequestWFHistory();
        } else {
          this.getAgentGuaranteeType(this.baseRequestDTO.RequestorId);
        }
        // } else if (this.requestStatus != ServiceStatus.Transit_PendingConfirmFeesPayment) {
        //   this.formMode = FormMode.Readonly;
        //   this.getTransitRequestWFHistory();
        // }
      }
    )
  }

  getAgentGuaranteeType(AgentId: string) {
    this.agentService.getAgentGuaranteeType(AgentId).subscribe(
      (data: ResponseObject) => {
        if (data.Success) {
          this.agentInfo = data.Data as AgentInfo;
          this.historicalGuaranteeType = this.agentInfo.GuaranteeType || '';
          this.historicalMaxValueNetTonnage = this.agentInfo.MaxValueNetTonnage || '';
        }
      }
    );
  }

  getTransitRequestWFHistory() {
    this.wfhistoryService.getByRequestIdByStepId(this.baseRequestId, this.stepId).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.stepData = this.responseObj.Data["StepData"] ? JSON.parse(this.responseObj.Data["StepData"]) : null;
          this.getTransitRequestWFHistoryCompleted(this.stepData);
        }
      }
    );
  }

  getTransitRequestWFHistoryById() {
    this.wfhistoryService.getByRequestIdByStepIdById(this.baseRequestId, this.stepId, this.stepHistoryId).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        this.stepData = this.responseObj.Data["StepData"] ? JSON.parse(this.responseObj.Data["StepData"]) : null;
        this.getTransitRequestWFHistoryCompleted(this.stepData);
      }
    );
  }

  getTransitRequestWFHistoryCompleted(stepData: any) {
    if (!stepData) return;
    this.decisionValue = this.stepData.Decision;
    this.changeDecision(this.decisionValue);
    if (this.decisionValue == ConfirmFeesPaymentDecision.CONFIRM) {
      this.confirmFeesPaymentForm.patchValue({
        SwiftCode: this.stepData.SwiftCode || '',
        GuaranteeType: this.stepData.GuaranteeType || '',
        MaxValueNetTonnage: this.stepData.MaxValueNetTonnage || ''
      });
    } else if (this.decisionValue == ConfirmFeesPaymentDecision.REQUIRE_MODIFICATION) {
      this.confirmFeesPaymentForm.patchValue({
        ModificationReason: this.stepData.ModificationReason || ''
      });
    }
    this.confirmFeesPaymentForm.disable();
  }

  onSubmit() {
    this.submitted = true;
    if (this.confirmFeesPaymentForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;
    this.transitRequestCustomObj.RequestId = this.baseRequestId;
    this.transitRequestCustomObj.IsEstimatedFeesPaid = this.confirmFeesPaymentForm.controls['Decision'].value == ConfirmFeesPaymentDecision.CONFIRM ? true : false;
    this.transitRequestCustomObj.PaymentStatus = this.confirmFeesPaymentForm.controls['Decision'].value == ConfirmFeesPaymentDecision.CONFIRM ? PaymentStatus.FULLY_PAID : PaymentStatus.NOT_PAID;
    this.transitRequestCustomObj.StepId = this.stepId;
    this.transitRequestCustomObj.StepData = JSON.stringify(this.confirmFeesPaymentForm.getRawValue());
    this.transitRequestCustomObj.CompletedBy = this.currentUser.UserName;
    this.transitRequestCustomObj.ComponentURL = this.router ? this.router.url.split('/')[1] + '/' + this.router.url.split('/')[2] : '';
    this.transitRequestCustomObj.IsAdmin = this.currentUser.IsAdmin;
    this.transitRequestCustomObj.DirectionId = this.GuaranteeDeductionLetters.TransitRequest.feesRequest.feesDetailsForm.get('DirectionId')?.value;
    if (this.decisionValue == ConfirmFeesPaymentDecision.CONFIRM){
      this.transitRequestCustomObj.GuaranteeType = this.confirmFeesPaymentForm.controls['GuaranteeType'].value == '' ? null : this.confirmFeesPaymentForm.controls['GuaranteeType'].value;
      this.transitRequestCustomObj.MaxValueNetTonnage = this.confirmFeesPaymentForm.controls['MaxValueNetTonnage'].value == '' ? null : this.confirmFeesPaymentForm.controls['MaxValueNetTonnage'].value;
    
    }
    this.transitRequestCustomObj.AgentId = this.baseRequestDTO.RequestorId;


    this.transitService.SubmitConfirmFeesPaymentDecision(this.transitRequestCustomObj)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            this.confirmFeesPaymentForm.reset();
            this.loading = false;
            this.showRequest = true;
            this.isErrorMessage = false;
          }
          else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            this.loading = false;
          }

        });
  }
}
